import { render, staticRenderFns } from "./AdsKpis.vue?vue&type=template&id=004c6343&scoped=true"
import script from "./AdsKpis.vue?vue&type=script&lang=js"
export * from "./AdsKpis.vue?vue&type=script&lang=js"
import style0 from "./AdsKpis.vue?vue&type=style&index=0&id=004c6343&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004c6343",
  null
  
)

export default component.exports